export const BUILTIN_SCENARIO_CONTEXT_AGENT_OPTIONS = [
    {
        value: "SCHEDULE_DRAFT_OPTIMIZER",
        displayName: "航班编排优化 Agent",
    },
];

const BUILTIN_AGENT_DISPLAY_NAMES = Object.fromEntries(BUILTIN_SCENARIO_CONTEXT_AGENT_OPTIONS.map((option) => [option.value, option.displayName]));

export function getScenarioContextAgentDisplayName(agentName) {
    return BUILTIN_AGENT_DISPLAY_NAMES[agentName] || agentName;
}

export function getScenarioContextAgentLabel(agentName) {
    const displayName = getScenarioContextAgentDisplayName(agentName);
    return displayName === agentName ? agentName : `${displayName} (${agentName})`;
}

export function normalizeScenarioContextAgentOptions(items = []) {
    const optionsByValue = new Map();

    const addOption = (item, { overwrite = true } = {}) => {
        const value = typeof item === "string" ? item : item?.value || item?.agent_name || item?.name;
        if (!value) {
            return;
        }
        if (!overwrite && optionsByValue.has(value)) {
            return;
        }

        const rawLabel = typeof item === "string" ? null : item?.label || item?.display_name || item?.displayName;
        const rawLabelText = rawLabel == null ? null : String(rawLabel);
        const label = rawLabelText ? (rawLabelText === value || rawLabelText.includes(value) ? rawLabelText : `${rawLabelText} (${value})`) : getScenarioContextAgentLabel(value);
        optionsByValue.set(value, { value, label });
    };

    items.forEach(addOption);
    BUILTIN_SCENARIO_CONTEXT_AGENT_OPTIONS.forEach((option) => addOption(option, { overwrite: false }));

    return Array.from(optionsByValue.values()).sort((a, b) => a.label.localeCompare(b.label, "zh-Hans"));
}
